export const drawerKeys: string[] = [
  'ADD',
  'ADD_CAT_SERIAL_NUMBER',
  'ADD_EQUIP_FIND_MODEL',
  'ADD_EQUIPMENT_DRAWER_HEADING',
  'ADD_EQUIPMENT_MODEL_PLACEHOLDER',
  'ADD_INV_CHAR_NEW_FIELD_WARNING',
  'ADD_MORE_EQUIPMENT',
  'ADD_SERIAL_NUMBER_NEW',
  'APP_COMMENT_BTN_DELETE',
  'BY_MODEL',
  'BY_SERIAL_EQUIP_SEARCH_DESC',
  'BY_SERIAL',
  'CANCEL',
  'RESET_PASSWORD_CANCEL',
  'CAT_CONTACT_US_TITLE',
  'CHANGE_EQUIPMENT',
  'CLEAR_SELECTION',
  'CONTACT_DEALER_CALL',
  'CONTACT_DEALER_CONTACT_FORM',
  'CONTACT_DEALER_VISIT',
  'CONTACT_FORM',
  'CURRENTLY_SHOPPING',
  'CURRENTLY_SHOPPING_FOR',
  'DELETE_EQUIPMENT',
  'DELETE_WIDGET_HEADER',
  'EDIT_EQUIP_SUCCESSFUL',
  'EMAIL_US',
  'EQUIP_ADDED_TO_LIST',
  'FIND_MODEL_GUIDE_TEXT',
  'FIND_SERIAL_GUIDE_TEXT',
  'FMS_SLIDE1_BODY',
  'FMS_SLIDE1_BODY2',
  'FMS_SLIDE1_TITLE',
  'FMS_SLIDE2_BODY_PREFIX',
  'FMS_SLIDE2_BODY_SEQID',
  'FMS_SLIDE2_BODY',
  'FMS_SLIDE2_BODY2',
  'FMS_SLIDE2_TITLE',
  'FMS_SLIDE3_BODY',
  'FMS_SLIDE3_TITLE',
  'FMS_SLIDE4_BODY',
  'FMS_SLIDE4_TITLE',
  'FOOTER_CONTACT_US',
  'GET_ADD_ATTACHMENT',
  'GUEST_EQUIPMENT_SAVE',
  'MEQ_ADD_EQUIP',
  'MEQ_ADD_FAILURE_TOAST',
  'MEQ_ADD_NOTIFICATION1',
  'MEQ_ADD_NOTIFICATION3',
  'MEQ_ADD_NOTIFICATION8',
  'MEQ_DELETE_MESSAGE',
  'MEQ_DESELECT_MESSAGE',
  'MEQ_DUPLICATE_EQUIPMENT_MESSAGE',
  'MEQ_DUPLICATE_EQUIPMENT_SELECT',
  'MEQ_EDIT_EQUIP',
  'MEQ_DEALER_MANAGED',
  'CONTACT_YOUR_DEALER',
  'KITS_CUSTOMIZE_KIT',
  'MEQ_LOADING_RESULTS',
  'MEQ_MODEL_NO_MATCH',
  'MEQ_MODEL_TRY_REFINING',
  'MEQ_NICKNAME',
  'MEQ_NO_EXACT_MATCH',
  'MEQ_OTHER_SUGGESTIONS',
  'MEQ_PARTS_FIT_CTA',
  'MEQ_SEARCH_TEXT',
  'MEQ_SERIAL_INVALID',
  'MEQ_SERIAL_MODEL_MATCH',
  'MEQ_SERIAL_MODEL_MATCH',
  'MEQ_SERIAL_MODEL_MESSAGE',
  'MEQ_SERIAL_NO_MATCH',
  'MEQ_SUPPORTED_EQUIP1',
  'MEQ_WARNING_MESSAGE',
  'MISSING_SERIAL_NUMBER',
  'MSTLST_ADD',
  'MY_EQUIP_FIND_SERIAL_TEXT1',
  'NO_EQUIPMENT_SELECTED',
  'NO',
  'ORDER_HISTORY_SERIALNUM_PLACEHOLDER',
  'PARTS_DIAGRAM_ADD_EQ_DESCRIPTION',
  'PLEASE_NOTE',
  'PREFIX_LABEL',
  'PREFIX',
  'SAVE',
  'SELECT_EQUIPMENT_FROM_LIST_MSG',
  'SELECT_EQUIPMENT_FROM_LIST',
  'SELECT_EQUIPMENT',
  'SEQUENCE_ID',
  'SHOP_PARTS',
  'SIGN_IN',
  'SL_REGISTER',
  'SPECIFY_PREF_DATE',
  'SUGGESTED_PREFIXES',
  'UNKONWN_ERROR',
  'UNKNOWN_ERROR_MESSAGE',
  'YES',
  'CAT_CONTACT_US_TITLE',
  'PDP_PARTSDIAGRAM_ADD_EQ_HEADING',
  'VIEW_PARTS_DIAGRAM',
  'ADD_SN_VIEW_PARTS_DIAGRAM',
  'YOUR_EQUIPMENT',
  'VIEW_DASHBOARD',
  'REQUEST_SERVICE_LOCATION',
  'PLEASE_NOTE',
  'MEQ_SUPPORTED_EQUIP1',
  'UC_NEXT',
  'UC_BACK',
  'REQUEST_SERVICE_DATE',
  'REQUEST_SERVICE_CONTACT',
  'FIRST_AVAILABLE',
  'REG_BIRTHDAY_DATE',
  'REQUEST_SERVICE_DATE',
  'THANK_YOU_1',
  'REQUEST_SERVICE_FIRST_AVAILABLE',
  'DELETE',
  'MEQ_FITEMENT_COMPONENT_CTA1',
  'MEQ_FITEMENT_COMPONENT_CTA2',
  'MEQ_PDP_FITMENT_CTA2',
  'MEQ_PDP_FITMENT_CTA3',
  'REQ_SERV_CNFRM_MSG',
  'PT_PRODUCT_ATTACHMENT',
  'SERVICE_REQUEST_INFORMATION',
  'CONFIRMATION',
  'UR_CAT_COMPANY',
  'CONTACT_MAIN',
  'TIME',
  'CAT_EMAIL_PHONE1',
  'MA_EMAIL',
  'MA_NAME',
  'RS_EQUIPMENT_SEARCH_FIELD',
  'CUST_EDIT',
  'DELETE_WISHLIST',
  'FREQUENTLY_BOUGHT_TOGETHER',
  'VIEW_ALL_PARTS',
  'PDP_THIS_ITEM'
];
